module.exports = __webpack_public_path__ + "static/img/cybercrime_1.62f71d40.png";